import { AVAILABLE_COUNTRIES_REGISTRATION, USE_BLS_THEME } from '@constants';

import type { CountryKey } from './countryUtils';

type CountryMap = { de: string } & Partial<Record<Exclude<CountryKey, 'de'>, string>>;

type BrandValue = string | CountryMap;

export type UrlSchema =
  | string
  | {
      bls?: BrandValue;
      probonio?: BrandValue;
    };

const resolveBrandValue = (value: BrandValue, tld?: CountryKey): string => {
  if (typeof value === 'string') {
    return tld ? value.replace(/\.de\b/, `.${tld}`) : value;
  }

  return (tld && value[tld]) ?? value.de;
};

export const resolveUrl = (url: UrlSchema): string => {
  const tld = window.location.hostname.split('.').pop()?.toLowerCase() as CountryKey | undefined;
  const isSupportedCountry = AVAILABLE_COUNTRIES_REGISTRATION.some(c => c.value.toLowerCase() === tld);

  const effectiveTld = isSupportedCountry && tld ? tld : undefined;

  if (typeof url === 'string') {
    return effectiveTld ? url.replace(/\.de\b/, `.${effectiveTld}`) : url;
  }

  const brandValue = USE_BLS_THEME ? url.bls : url.probonio;
  if (!brandValue) throw new Error('URL not configured for active brand');

  return resolveBrandValue(brandValue, effectiveTld);
};
